import createEditTaskPanelReducer from './editPanel/reducer'
import {combineReducers} from 'redux'
import createNewTaskPanelReducer from './createPanel/reducer'

export default (initAppData) => combineReducers({
    edit: createEditTaskPanelReducer(initAppData),
    create: createNewTaskPanelReducer(initAppData),
})


// WEBPACK FOOTER //
// ./web/js/panels/task/reducer.js